module.exports = __webpack_public_path__ + "static/media/business.f46072ea.jpg";